import type { SeoPageType } from '@jane/business-admin/data-access';

// defaults come from api/app/models/bloom_operator_config.rb
export const DEFAULT_SEO_VALUES = {
  category: {
    title:
      'Shop {{ tabName }} cannabis products | {{ storeName }} Dispensary {{ storeCity }}, {{ storeStateAbbr }}',
    description:
      'Visit {{ storeName }} dispensary in {{ storeCity }}, {{ storeStateAbbr }} and order {{ storeFulfillment }} cannabis online products for {{ storeType }}. Browse our online dispensary menu for flower, edibles, vape and more.',
  },
  customRow: {
    title:
      'Shop {{ rowName }} products | {{ storeName }} Dispensary {{ storeCity }}, {{ storeStateAbbr }}',
    description:
      'Visit {{ storeName }} dispensary in {{ storeCity }}, {{ storeStateAbbr }} and order {{ storeFulfillment }} cannabis online products for {{ storeType }}. Browse our online dispensary menu for flower, edibles, vape and more.',
  },
  deal: {
    title:
      'Shop {{ specialName }} products | {{ storeName }} Dispensary {{ storeCity }}, {{ storeStateAbbr }}',
    description:
      'Visit {{ storeName }} dispensary in {{ storeCity }}, {{ storeStateAbbr }} and order {{ storeFulfillment }} cannabis online products for {{ storeType }}. Browse our online dispensary menu for flower, edibles, vape and more.',
  },
  featured: {
    title:
      'Shop featured cannabis products | {{ storeName }} Dispensary {{ storeCity }}, {{ storeStateAbbr }}',
    description:
      'Visit {{ storeName }} dispensary in {{ storeCity }}, {{ storeStateAbbr }} and order {{ storeFulfillment }} cannabis online products for {{ storeType }}. Browse our online dispensary menu for flower, edibles, vape and more.',
  },
  pdp: {
    title:
      'Shop {{ productName }} | {{ storeName }} Dispensary {{ storeCity }}, {{ storeStateAbbr }}',
    description:
      'Visit {{ storeName }} dispensary in {{ storeCity }}, {{ storeStateAbbr }} and order {{ storeFulfillment }} cannabis online products for {{ storeType }}. Browse our online dispensary menu for flower, edibles, vape and more.',
  },
  shopAll: {
    title:
      'Shop all products | {{ storeName }} Dispensary {{ storeCity }}, {{ storeStateAbbr }}',
    description:
      'Visit {{ storeName }} dispensary in {{ storeCity }}, {{ storeStateAbbr }} and order {{ storeFulfillment }} cannabis online products for {{ storeType }}. Browse our online dispensary menu for flower, edibles, vape and more.',
  },
};

export const SEO_VARIABLES = {
  category: [
    'storeName',
    'storeCity',
    'storeStateAbbr',
    'storeType',
    'storeFulfillment',
    'tabName',
  ],
  customRow: [
    'storeName',
    'storeCity',
    'storeStateAbbr',
    'storeType',
    'storeFulfillment',
    'rowName',
  ],
  deal: [
    'storeName',
    'storeCity',
    'storeStateAbbr',
    'storeType',
    'storeFulfillment',
    'specialName',
    'rowName',
  ],
  featured: [
    'storeName',
    'storeCity',
    'storeStateAbbr',
    'storeType',
    'storeFulfillment',
  ],
  pdp: [
    'storeName',
    'storeCity',
    'storeStateAbbr',
    'storeType',
    'storeFulfillment',
    'productName',
    'productLineage',
    'productCategory',
    'productSubCategory',
    'productBrand',
  ],
  shopAll: [
    'storeName',
    'storeCity',
    'storeStateAbbr',
    'storeType',
    'storeFulfillment',
    'tabName',
  ],
};

export const SEO_URLS = {
  category: '/shop/category',
  customRow: '/shop/customRow/<id>/<rowName>',
  deal: '/shop/deals/<id>/<slug>',
  featured: '/shop',
  pdp: '/shop/products/<id>/<slug>',
  shopAll: '/shop/shop-all',
};

interface NavLink {
  label: string;
  value: SeoPageType;
}

export const NAV_LINKS: NavLink[] = [
  { label: 'Featured', value: 'featured' },
  { label: 'Category', value: 'category' },
  { label: 'Deal', value: 'deal' },
  { label: 'Shop All', value: 'shopAll' },
  { label: 'Custom Row', value: 'customRow' },
  { label: 'PDP', value: 'pdp' },
];
